export default class Product {
  product: object;
  static recentlyViewedProductsCookie = 'recentlyViewedProducts';
  static currentTimestamp: number;
  static expirationTimestamp: number;

  constructor(product) {
    this.product = product;
    this.addProductInRecentlyViewedProducts(this.product);
  }

  addProductInRecentlyViewedProducts(product) {
    let products = Product.getRecentlyViewedProducts();
    product.timestamp = Product.currentTimestamp;
    // We'll remove the product if it is in the products array
    products = products.filter((p) => p.modelReference !== product.modelReference);
    // Then we'll add it at the beginning of the product array
    products.unshift(product);
    // We keep only the 10 first products as we don't want to have too many products in the cookie
    products = products.slice(0, 10);

    const cookieData = Product.getCookieData();
    cookieData[window.Phoenix.defaultCountryCode] = products;
    localStorage.setItem(Product.recentlyViewedProductsCookie, JSON.stringify(cookieData));
  }

  static setTimestamps() {
    if (!Product.currentTimestamp) {
      Product.currentTimestamp = Date.now();
      Product.expirationTimestamp = Product.currentTimestamp - 5 * 24 * 60 * 60;
    }
  }

  static getRecentlyViewedProducts() {
    this.setTimestamps();
    const products = Product.getCookieData()[window.Phoenix.defaultCountryCode] || [];
    return products.filter((p) => p.timestamp > Product.expirationTimestamp);
  }

  private static getCookieData() {
    return JSON.parse(localStorage.getItem(Product.recentlyViewedProductsCookie) || '{}');
  }
}
